import { Link } from "react-router-dom";
import { useSeo } from "../lib/seo";

export default function NotFound() {
  useSeo({
    title: "Seite nicht gefunden",
    description: "Diese Seite existiert nicht oder wurde verschoben.",
    noindex: true,
  });

  return (
    <div className="max-w-3xl mx-auto px-6 py-32 text-center" data-testid="not-found-page">
      <h1 className="nx-head text-4xl sm:text-5xl tracking-tighter font-medium">Seite nicht gefunden</h1>
      <p className="mt-5 text-sm text-zinc-400">
        Diese Seite existiert nicht oder wurde verschoben. Hier geht es weiter:
      </p>
      <div className="mt-10 flex flex-wrap gap-3 justify-center">
        <Link to="/" className="nx-btn">Zur Startseite</Link>
        <Link to="/leistungen" className="nx-btn-ghost">Leistungen</Link>
        <Link to="/einsatzgebiete" className="nx-btn-ghost">Einsatzgebiete</Link>
      </div>
    </div>
  );
}
